import { useParams } from "react-router";
import { useAppSelector } from "../../../app/hooks";
import { useCaseFindQuery } from "../../../services/scheduleService/schedule-api";

export function usePrimaryPayerCode(): string {
    const { id } = useParams();
    const verification = useAppSelector((state) => state.verification.verification);
    const schedule = useCaseFindQuery(id!);
    const primaryPayer = schedule.data?.insurances.find(p => p.priority === 1);
    return primaryPayer?.payerCode || verification.primaryPayerId || '';
}
